
const vipRank = {
      path: '/memberManage/vipRank',
      component: resolve => require(['@/views/membMange/vipRank'], resolve),
      name: 'vipRank',
      meta: {title: 'VIP等级管理'}
    };
const vipRankDetail = {
  path: '/memberManage/vipRankDetail',
  component: resolve => require(['@/views/membMange/vipRankDetail'], resolve),
  name: 'vipRankDetail',
  meta: {title: '等级管理详情'},
  hidden: true
};
const upgradeLogs = {
      path: '/memberManage/upgradeLogs',
      component: resolve => require(['@/views/membMange/upgradeLogs'], resolve),
      name: 'upgradeLogs',
      meta: {title: 'VIP升级记录',keepActive:true}
    };
const upgradeTotal = {
    path: '/memberManage/upgradeTotal',
    component: resolve => require(['@/views/membMange/upgradeTotal'], resolve),
    name: 'upgradeTotal',
    meta: {title: 'VIP升级统计',keepActive:true}
};
const recepTion = {
      path: '/memberManage/recepTion',
      component: resolve => require(['@/views/membMange/recepTion'], resolve),
      name: 'recepTion',
      meta: {title: '前台会员列表',keepActive:true}
    };
const accessLog = {
      path: '/memberManage/accessLog',
      component: resolve => require(['@/views/membMange/accessLog'], resolve),
      name: 'accessLog',
      meta: {title: '用户访问日志'}
    };
const receptionTotal = {
    path: '/memberManage/receptionTotal',
    component: resolve => require(['@/views/membMange/receptionTotal'], resolve),
    name: 'receptionTotal',
    meta: {title: '前台会员统计',keepActive:true}
    };
const realName = {
      path: '/memberManage/realName',
      component: resolve => require(['@/views/membMange/realName'], resolve),
      name: 'realName',
      meta: {title: '实名认证',keepActive:true}
    };
const receiptLevel = {
      path: '/memberManage/receiptLevel',
      component: resolve => require(['@/views/membMange/receiptLevel'], resolve),
      name: 'receiptLevel',
      meta: {title: '用户等级管理'}
    };
const userCraft = {
      path: '/memberManage/userCraft',
      component: resolve => require(['@/views/membMange/userCraft'], resolve),
      name: 'userCraft',
      meta: {title: '会员手艺',keepActive:true}
    };
const waitAudit = {
  path: '/memberManage/waitAudit',
  component: resolve => require(['@/views/membMange/waitAudit'], resolve),
  name: 'waitAudit',
  meta: {title: '待审核手艺',keepActive:true}
};
const userPledge = {
    path: '/memberManage/userPledge',
    component: resolve => require(['@/views/membMange/userPledge'], resolve),
    name: 'userPledge',
    meta: {title: '会员保证金',keepActive:true}
};
const userPledgeDetail = {
    path: '/memberManage/userPledgeDetail',
    component: resolve => require(['@/views/membMange/userPledgeDetail'], resolve),
    name: 'userPledge',
    meta: {title: '会员保证明细'}
};

const userAccountSet = {
    path: '/memberManage/accountSet',
    component: resolve => require(['@/views/membMange/accountSet'], resolve),
    name: 'userAccountSet',
    meta: {title: '会员积分设置'}
};
const userAccount = {
    path: '/memberManage/account',
    component: resolve => require(['@/views/membMange/account'], resolve),
    name: 'userAccount',
    meta: {title: '会员积分'}
};
const userAccountLog = {
    path: '/memberManage/accountLog',
    component: resolve => require(['@/views/membMange/accountLog'], resolve),
    name: 'userAccountLog',
    meta: {title: '会员积分日志'}
};
const userAccountRecharge = {
    path: '/memberManage/accountRecharge',
    component: resolve => require(['@/views/membMange/accountRecharge'], resolve),
    name: 'userAccountRecharge',
    meta: {title: '会员积分充值'}
};
const accountPartner = {
    path: '/memberManage/accountPartner',
    component: resolve => require(['@/views/membMange/accountPartner'], resolve),
    name: 'accountPartner',
    meta: {title: '积分推广用户'}
};

const accountMoneyCheck = {
    path: '/memberManage/accountMoneyCheck',
    component: resolve => require(['@/views/membMange/accountMoneyCheck'], resolve),
    name: 'accountMoneyCheck',
    meta: {title: '积分推广核对'}
};

export default [vipRank, upgradeLogs,upgradeTotal, recepTion,accessLog,receptionTotal, realName,  receiptLevel, userCraft,waitAudit,vipRankDetail,userPledge,userPledgeDetail,userAccountSet,userAccount,userAccountLog,userAccountRecharge,accountPartner,accountMoneyCheck];



// WEBPACK FOOTER //
// ./src/router/modules/membMange.js